import { Component, Input, OnInit, inject } from '@angular/core';
import { ClientConsultNoteTask } from 'app/core/models/client-consult-note-task.model';
import { TaskFilters } from 'app/core/models/user-settings/task-settings.model';
import { ClientConsultNoteTasksService, PagedClientConsultNoteTasks } from 'app/core/services/client-consult-note-tasks.service';
import { DatePipe } from '@angular/common';
import { RouterLinkActive, RouterLink } from '@angular/router';
import { PrescriberNameComponent } from '../../../shared/components/prescriber-name/prescriber-name.component';
import { TaskEstimatedValueComponent } from '../../../shared/components/task-estimated-value/task-estimated-value.component';
import { ExpirationDateComponent } from '../../../shared/components/expiration-date/expiration-date.component';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { TaskStatusPipe } from '../../../shared/pipes/task-status.pipe';

const defaultRelatedTaskSize = 5;

@Component({
    selector: 'app-client-consult-note-task-related-tasks',
    templateUrl: './client-consult-note-task-related-tasks.component.html',
    styleUrls: ['./client-consult-note-task-related-tasks.component.scss'],
    imports: [RouterLinkActive,
              RouterLink,
              PrescriberNameComponent,
              TaskEstimatedValueComponent,
              ExpirationDateComponent,
              MatProgressSpinner,
              DatePipe,
              TaskStatusPipe]
})
export class ClientConsultNoteTaskRelatedTasksComponent implements OnInit {
  private clientConsultNoteTasksService = inject(ClientConsultNoteTasksService);

  @Input() task: ClientConsultNoteTask;

  loadingRelatedTasks = true;
  showingAll = false;

  filters: TaskFilters = new TaskFilters();
  relatedTasks: ClientConsultNoteTask[] = [];
  totalRelatedTasks: number;

  ngOnInit() {
    this.init();
  }

  public get showSeeAll() {
    if (this.showingAll) {
      return false;
    } else {
      return this.totalRelatedTasks && this.totalRelatedTasks > (defaultRelatedTaskSize + 1);
    }
  }

  public clickSeeAll($event) {
    $event.preventDefault();
    this.showingAll = true;
    this.loadPatientTasks(this.totalRelatedTasks);
  }

  private init() {
    this.filters.patientId = this.task.patient.id;
    this.loadPatientTasks(defaultRelatedTaskSize + 1);
  }

  private loadPatientTasks(count) {
    const paging = { page: 1, pageSize: count };
    this.clientConsultNoteTasksService.getList(paging, this.filters).subscribe(
      (result: PagedClientConsultNoteTasks) => {
        this.relatedTasks = this.buildRelatedTasks(result, count);
        this.totalRelatedTasks = result.meta.paging.count;
        this.loadingRelatedTasks = false;
      }
    );
  }

  private buildRelatedTasks(result: PagedClientConsultNoteTasks, count: number) {
    const filteredTasks = result.clientConsultNoteTasks.filter( (t) => t.id !== this.task.id );
    return filteredTasks.slice(0, count - 1);
  }
}
